import { frontendOptions } from "../../../../../lib/systemData";
import WorkQDeferredCustomSelect from "../../../cells/WorkQDeferredCustomSelect";
import WorkQDeferredTooltip from "../../../cells/WorkQDeferredTooltip";

export default function FollowUpQStatusItem({classes, item, type, updateHandler, workQtype}) {

    let modalHTML = item.workq_call_follow_up[`${type}user`] ? `Modified by ${item.workq_call_follow_up[`${type}user`].name}` : null
    return <td className={`${classes.td_cell_no_padding} ${classes.td_cell_height_100}`}>
        {item.patient && <>
            <WorkQDeferredTooltip mode="v3" message={modalHTML} disabled={!modalHTML}>
                <WorkQDeferredCustomSelect
                    optionsData={workQtype == 'frontdesk' ? frontendOptions()?.FRONT_DESK_FOLLOW_UP_STATUS : frontendOptions()?.MANAGEMENT_FOLLOW_UP_STATUS}
                    preSelectedValue={item.workq_call_follow_up[`${type}status`]}
                    action={updateHandler}
                    name={`${type}status`}
                    identifier={{type: 'workq_call_follow_up', field: `${type}status`, type_id: null, folder: null, case_id: item.case?.id}}
                    sameSizeAsContainer={true}
                    minWidth={150}
                    hasRemove={true}
                    openOnShellClick={true}
                    undetermined="Expected"
                />
            </WorkQDeferredTooltip>
        </>}
    </td> 
}